import FlightAlerts from "@/components/flights/FlightAlerts";
import DivertedFlightAlerts from "@/components/flights/DivertedFlightAlerts";
import CurrentFlightsMap from "@/components/flights/CurrentFlightsMap";
export default [
  {
    path: "/flightalerts",
    name: "FlightAlerts",
    component: FlightAlerts,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/divertedflightalerts",
    name: "DivertedFlightAlerts",
    component: DivertedFlightAlerts,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/current-flights-map",
    name: "CurrentFlightsMap",
    component: CurrentFlightsMap,
    meta: {
      requiresAuthentication: true
    }
  }
];
